export const graphAssignation = {
};